import * as React from "react";
import {
  Box,
  IconButton,
  TextField,
  Paper,
  CircularProgress,
  Typography,
} from "@mui/material";
import {
  Add as AddIcon,
  Mic as MicIcon,
  ArrowUpward as ArrowUpwardIcon,
} from "@mui/icons-material";

interface ChatFieldProps {
  message: string;
  onMessageChange: (message: string) => void;
  onSend: () => void;
  maxWidth?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

export const ChatField: React.FC<ChatFieldProps> = ({
  message,
  onMessageChange,
  onSend,
  maxWidth = "926px",
  disabled = false,
  isLoading = false,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSend();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (message.trim()) {
        onSend();
      }
    }
    // Shift+Enter permette il comportamento di default (nuova riga)
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth,
      }}
    >
      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{
          width: "100%",
          maxWidth,
          p: 2,
          borderRadius: 8,
          bgcolor: "#FFFFFF",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          border: "1px solid #E0E0E0",
          display: "flex",
          flexDirection: "column",
          gap: 0,
        }}
      >
        <TextField
          fullWidth
          multiline
          placeholder="Come posso aiutarti oggi?"
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          onKeyDown={handleKeyDown}
          variant="standard"
          disabled={disabled}
          InputProps={{
            disableUnderline: true,
          }}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "1rem",
              color: "#424242",
              "&::placeholder": {
                color: "#9E9E9E",
                opacity: 1,
              },
            },
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1,
            mt: 0.5,
          }}
        >
          {
            //<IconButton sx={{ color: "#666666", p: "6px" }}>
            //  <AddIcon />
            //</IconButton>
            //<IconButton sx={{ color: "#666666", p: "6px" }}>
            //  <MicIcon />
            //</IconButton>
          }
          <IconButton
            type={isLoading ? "button" : "submit"}
            disabled={
              (!isLoading && !message.trim()) || (disabled && !isLoading)
            }
            sx={{
              bgcolor: "#000000",
              color: "#FFFFFF",
              width: 36,
              height: 36,
              "&:hover": {
                bgcolor: isLoading ? "#000000" : "#333333",
              },
              "&.Mui-disabled": {
                bgcolor: "#E0E0E0",
                color: "#9E9E9E",
              },
            }}
          >
            {isLoading ? (
              <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
            ) : (
              <ArrowUpwardIcon sx={{ fontSize: "1.2rem" }} />
            )}
          </IconButton>
        </Box>
      </Paper>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyItems: "center",
          mt: 0.5,
        }}
      >
        <Typography
          variant="caption"
          color="#A0A0A0"
          sx={{
            display: "text.",
            mt: 1,
            textAlign: "center",
            px: 2,
            width: "100%",
          }}
        >
          I modelli AI possono sbagliare, verifica le fonti. Sei tu il
          consulente che ha l&apos;ultima parola.
        </Typography>
      </Box>
    </Box>
  );
};
